import React from "react";

interface Header {
    content: string;
    sortColumn: string;
    type?: string;
    modal?: string;
}

interface PricingTableHeadProps {
    headers: Header[];
    data?: any;
    setSort: (sort: string) => void;
    sortOrder: string;
    setSortOrder: (order: string) => void;
}

const PricingTableHead: React.FC<PricingTableHeadProps> = ({
    headers,
    data,
    setSort,
    sortOrder,
    setSortOrder
}) => {

    const changeSorting = (sort: string) => {
        const orderBy = sortOrder === 'ASCENDING' ? 'DESCENDING' : 'ASCENDING';
        setSort(sort);
        setSortOrder(orderBy);
    };

    return (
        <thead className="bg-highlight-0 text-text-0 sticky top-0">
            <tr>
                {headers.map((header, index) => (
                    <th key={index} scope="col" className="text-center px-4 py-2 bg-highlight-0 text-text-0 whitespace-nowrap">
                        {data && data?.data ? (
                            data?.sortColumn === header.sortColumn ? (
                                data?.sortOrder === "ASCENDING" ? (
                                    <button
                                        onClick={() => changeSorting(header.sortColumn)}
                                        className="flex items-center justify-center gap-1 cursor-pointer hover:text-gray-300"
                                    >
                                        {header.content}  <i className="fas fa-sort-up" />
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => changeSorting(header.sortColumn)}
                                        className="flex items-center justify-center gap-1 cursor-pointer hover:text-gray-300"
                                    >
                                        {header.content} <i className="fas fa-sort-down" />
                                    </button>
                                )
                            ) : header.sortColumn ? (
                                <button
                                    onClick={() => changeSorting(header.sortColumn)}
                                    className="flex items-center justify-center gap-1 cursor-pointer hover:text-gray-300"
                                >
                                    {header.content} <i className="fas fa-sort" />
                                </button>
                            ) : header.type !== "Action" ? (
                                <span className="text-gray-300">{header.content}</span>
                            ) : (
                                <button
                                    data-target={header.modal}
                                    data-toggle="modal"
                                className="text-gray-300 hover:text-text-0"
                                >
                                    <i className="fa fa-plus-circle" title={header.content} />
                                </button>
                            )
                        ) : header.sortColumn ? (
                            <button className="text-gray-300 flex items-center justify-center gap-1">
                                {header.content} <i className="fas fa-sort" />
                            </button>
                        ) : header.type !== "Action" ? (
                            <span className="text-gray-300">{header.content}</span>
                        ) : (
                        <button data-target={header.modal} data-toggle="modal" className="text-gray-300 hover:text-text-0">
                                <i className="fa fa-plus-circle" title={header.content} />
                            </button>
                        )}
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default PricingTableHead;
